import { IInstallmentsState } from 'v3/data/store/installments/types';

export const installmentsInitialState: IInstallmentsState = {
  item: {
    contractId: '',
    installments: [],
  },
  itemsToPay: [],
  totalToPay: 0,
  contractingKey: '',
  pix: {
    pixCode: '',
    qrCode: '',
    value: 0,
    expirationSeconds: 0,
  },
};
